/* Strictli theme scripts: carousels, phone menu, collection filters, product
   page (variant picker, gallery, quantity), recommendations and cart. */

(function () {
  /* ---------- Sticky header height, used by sticky sidebars ---------- */
  function setHeaderHeight() {
    var header = document.querySelector('.site-header');
    if (header) document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
  }

  /* ---------- Carousels ---------- */
  function initCarousel(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';

    var track = root.querySelector('[data-carousel-track]');
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    var progress = root.querySelector('[data-carousel-progress]');
    if (!track) return;

    function update() {
      var max = Math.max(0, track.scrollWidth - track.clientWidth);
      var current = Math.max(0, track.scrollLeft);
      if (prev) prev.disabled = current <= 2;
      if (next) next.disabled = current >= max - 2;
      if (progress) {
        var visible = track.scrollWidth > 0 ? track.clientWidth / track.scrollWidth : 1;
        var position = max > 0 ? current / max : 0;
        progress.style.width = Math.min(100, (visible + position * (1 - visible)) * 100) + '%';
      }
    }

    function move(direction) {
      var slide = track.firstElementChild;
      if (!slide) return;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      track.scrollBy({ left: (slide.getBoundingClientRect().width + gap) * direction, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Collection filters: apply on change ---------- */
  function initFilters(form) {
    if (form.dataset.ready) return;
    form.dataset.ready = 'true';
    var timer;

    function apply() {
      var params = new URLSearchParams();
      new FormData(form).forEach(function (value, key) {
        if (value !== '') params.append(key, value);
      });
      form.setAttribute('aria-busy', 'true');
      window.location.href = form.action.split('?')[0] + (params.toString() ? '?' + params.toString() : '');
    }

    form.addEventListener('change', function (event) {
      if (event.target.matches('[data-filter-debounce]')) return;
      apply();
    });
    form.addEventListener('input', function (event) {
      if (!event.target.matches('[data-filter-debounce]')) return;
      clearTimeout(timer);
      timer = setTimeout(apply, 900);
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      apply();
    });

    /* Filters start closed on phones */
    var filters = form.querySelector('[data-filters]');
    if (filters && window.matchMedia('(max-width: 989px)').matches) filters.removeAttribute('open');
  }

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-quantity] [data-step]');
    if (!button) return;
    var input = button.parentElement.querySelector('input');
    var min = parseInt(input.min, 10) || 0;
    var value = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(button.dataset.step, 10));
    if (String(value) === input.value) return;
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product page ---------- */
  function initProduct(section) {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';

    var sectionId = section.dataset.sectionId;
    var gallery = section.querySelector('[data-gallery]');
    var request;

    function showMedia(mediaId, smooth) {
      if (!gallery || !mediaId) return;
      var slide = gallery.querySelector('[data-media-id="' + mediaId + '"]');
      if (!slide) return;
      gallery.scrollTo({ left: slide.offsetLeft - gallery.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      markThumb(mediaId);
    }

    function markThumb(mediaId) {
      section.querySelectorAll('[data-thumb]').forEach(function (thumb) {
        if (thumb.dataset.thumb === String(mediaId)) {
          thumb.setAttribute('aria-current', 'true');
          /* Scroll only the thumbnail row: scrollIntoView would move the page too */
          var row = thumb.closest('.product-thumbs');
          if (row) {
            var start = thumb.offsetLeft - row.offsetLeft;
            if (start < row.scrollLeft) row.scrollLeft = start;
            else if (start + thumb.offsetWidth > row.scrollLeft + row.clientWidth) row.scrollLeft = start + thumb.offsetWidth - row.clientWidth;
          }
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    }

    section.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-thumb]');
      if (thumb) showMedia(thumb.dataset.thumb);
    });

    if (gallery) {
      /* Start on the image the page was opened for (?variant= links) */
      var initial = gallery.dataset.initialMedia;
      if (initial && gallery.firstElementChild && gallery.firstElementChild.dataset.mediaId !== initial) {
        showMedia(initial, false);
      }
      var scrollTimer;
      gallery.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var index = Math.round(gallery.scrollLeft / gallery.clientWidth);
          var slide = gallery.children[index];
          if (slide) markThumb(slide.dataset.mediaId);
        }, 80);
      }, { passive: true });
    }

    /* App blocks that show nothing on this product shouldn't leave a gap in the
       buy box. They stay in the page so an app can still fill them later. */
    if (window.ResizeObserver) {
      var collapse = new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
          entry.target.classList.toggle('is-collapsed', entry.contentRect.height === 0);
        });
      });
      section.querySelectorAll('.product__app, .product__warranty').forEach(function (block) {
        collapse.observe(block);
      });
    }

    function variants() {
      var data = section.querySelector('[data-variants]');
      return data ? JSON.parse(data.textContent) : [];
    }

    function selectedOptions() {
      var picker = section.querySelector('[data-variant-picker]');
      return Array.prototype.map.call(picker.querySelectorAll('fieldset'), function (fieldset) {
        var checked = fieldset.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(changedPosition) {
      var list = variants();
      var options = selectedOptions();
      var exact = list.find(function (v) {
        return v.options.every(function (value, i) { return value === options[i]; });
      });
      if (exact && exact.available) return exact;
      /* That combination can't be bought (sold out, unpriced or nonexistent;
         catalogs mix option sets), so keep the value the customer just picked
         and take the closest match that can. */
      var picked = options[changedPosition - 1];
      var candidates = list.filter(function (v) { return v.available && v.options[changedPosition - 1] === picked; });
      candidates.sort(function (a, b) {
        var score = function (v) {
          return v.options.filter(function (value, i) { return value === options[i]; }).length;
        };
        return score(b) - score(a);
      });
      return candidates[0] || exact;
    }

    function render(variant) {
      section.querySelectorAll('input[name="id"]').forEach(function (input) {
        input.value = variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      var url = section.dataset.productUrl + '?variant=' + variant.id;
      window.history.replaceState({}, '', url);
      if (variant.media) showMedia(variant.media);

      if (request) request.abort();
      request = new AbortController();
      section.setAttribute('aria-busy', 'true');
      fetch(url + '&section_id=' + sectionId, { signal: request.signal })
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          section.querySelectorAll('[data-swap]').forEach(function (element) {
            var fresh = doc.querySelector('[data-swap="' + element.dataset.swap + '"]');
            if (fresh) element.replaceWith(fresh);
          });
          section.removeAttribute('aria-busy');
        })
        .catch(function (error) {
          if (error.name !== 'AbortError') window.location.href = url;
        });
    }

    section.addEventListener('change', function (event) {
      var input = event.target;
      if (!input.matches('[data-option-position]')) return;
      var variant = findVariant(parseInt(input.dataset.optionPosition, 10));
      if (variant) render(variant);
    });
  }

  /* ---------- Add to cart ----------
     Adds through /cart/add.js, then opens the cart. Apps such as SureBright
     (warranties) and Selleasy hook into these background requests to add
     their items; a plain form post would skip them. Falls back to the
     normal form post if the request fails. */
  function initProductForm(form) {
    if (form.dataset.ready) return;
    form.dataset.ready = 'true';
    form.addEventListener('submit', function (event) {
      if (form.dataset.posting) return;
      event.preventDefault();
      var button = form.querySelector('[name="add"]');
      if (button) button.setAttribute('aria-busy', 'true');
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add failed');
          return response.json();
        })
        .then(function () {
          /* Give app interceptors a moment to finish their own cart calls */
          setTimeout(function () { window.location.href = root + 'cart'; }, 400);
        })
        .catch(function () {
          form.dataset.posting = 'true';
          form.submit();
        });
    });
  }

  /* ---------- Recommendations (related, complementary) ---------- */
  function initRecommendations(root) {
    if (root.dataset.ready || !root.dataset.url) return;
    root.dataset.ready = 'true';
    var load = function () {
      fetch(root.dataset.url)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById(root.id);
          if (fresh && fresh.innerHTML.trim()) {
            root.innerHTML = fresh.innerHTML;
            root.querySelectorAll('[data-carousel]').forEach(initCarousel);
          }
        })
        .catch(function () {});
    };
    if (!('IntersectionObserver' in window)) return load();
    var observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      load();
    }, { rootMargin: '0px 0px 600px 0px' });
    observer.observe(root);
  }

  /* ---------- Cart page: update quantities without a button ---------- */
  function initCart(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    var timer;
    root.addEventListener('change', function (event) {
      if (!event.target.matches('[data-cart-quantity]')) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        var form = root.querySelector('[data-cart-form]');
        var updates = Array.prototype.map.call(root.querySelectorAll('[data-cart-quantity]'), function (input) {
          return Math.max(0, parseInt(input.value, 10) || 0);
        });
        form.setAttribute('aria-busy', 'true');
        fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/update.js' : '/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates, sections: [root.dataset.cartSection] })
        })
          .then(function (response) { return response.json(); })
          .then(function (cart) {
            var html = cart.sections && cart.sections[root.dataset.cartSection];
            if (!html) return window.location.reload();
            var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-section]');
            root.replaceWith(fresh);
            initCart(fresh);
            document.querySelectorAll('.site-header__cart-count').forEach(function (count) {
              count.textContent = cart.item_count;
              count.hidden = cart.item_count === 0;
            });
          })
          .catch(function () { window.location.reload(); });
      }, 400);
    });
  }

  /* ---------- Blog: keep the current blog/topic pill in view on phones ---------- */
  function revealCurrentPill(row) {
    var current = row.querySelector('[aria-current]');
    if (current && row.scrollWidth > row.clientWidth) {
      row.scrollLeft = current.offsetLeft - row.offsetLeft - 16;
    }
  }

  function initAll() {
    setHeaderHeight();
    document.querySelectorAll('.blog-switcher, .blog-tags').forEach(revealCurrentPill);
    document.querySelectorAll('[data-carousel]').forEach(initCarousel);
    document.querySelectorAll('[data-filter-form]').forEach(initFilters);
    document.querySelectorAll('[data-type-filter]').forEach(initTypeFilter);
    document.querySelectorAll('[data-product-section]').forEach(initProduct);
    document.querySelectorAll('[data-product-form]').forEach(initProductForm);
    document.querySelectorAll('[data-recommendations]').forEach(initRecommendations);
    document.querySelectorAll('[data-cart-section]').forEach(initCart);
  }

  /* Device type buttons on deal collections: show one type without reloading the page.
     The choice stays in the address, and through filter and sort changes. */
  function initTypeFilter(root) {
    var section = root.closest('.collection-page');
    var form = section.querySelector('[data-filter-form]');
    var items = section.querySelectorAll('#ProductGrid > li');
    var count = section.querySelector('.collection-toolbar__count');
    var totalText = count ? count.textContent : '';
    var buttons = root.querySelectorAll('[data-type-value]');
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'type';
    form.appendChild(input);

    function apply(type, updateAddress) {
      var match = Array.prototype.some.call(buttons, function (button) {
        return button.dataset.typeValue === type;
      });
      if (!match) type = '';
      var shown = 0;
      items.forEach(function (item) {
        var show = !type || item.dataset.type === type;
        item.hidden = !show;
        if (show) shown += 1;
      });
      buttons.forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.typeValue === type));
      });
      if (count) count.textContent = type ? shown + (shown === 1 ? ' product' : ' products') : totalText;
      input.value = type;
      input.disabled = !type;
      if (updateAddress) {
        var url = new URL(window.location.href);
        if (type) url.searchParams.set('type', type);
        else url.searchParams.delete('type');
        window.history.replaceState({}, '', url);
      }
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        apply(button.dataset.typeValue, true);
      });
    });
    apply(new URL(window.location.href).searchParams.get('type') || '', false);
  }

  /* Close the phone menu with Escape or when tapping outside it. */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.site-header__drawer[open]').forEach(function (drawer) {
      drawer.removeAttribute('open');
      drawer.querySelector('summary').focus();
    });
  });
  document.addEventListener('click', function (event) {
    document.querySelectorAll('.site-header__drawer[open]').forEach(function (drawer) {
      if (!drawer.contains(event.target)) drawer.removeAttribute('open');
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  window.addEventListener('resize', setHeaderHeight);
  document.addEventListener('shopify:section:load', initAll);
})();
